<div mat-dialog-title>
  <h1>
    {{ data.user.name }} <span>({{ data.user.credits }})</span>
  </h1>
  <p class="history-subtitle">Credits historie</p>
</div>
<div mat-dialog-content>
  @if (!loading()) {
    <div class="history-list">
      @if (history().length === 0) {
        <p>Deze passagier heeft nog geen credits gehad.</p>
      }
      @for (historyItem of history(); track historyItem.id) {
        <div class="history-list-item">
          <h4 class="item-title">{{ historyItem.description }}</h4>
          @if (historyItem.date && historyItem.type === 'incasso_notice') {
            <p class="item-change">
              {{ historyItem.date.toDate() | date: 'd/MM/yyyy HH:mm' }}
            </p>
          }
          @if (historyItem.creditsAdded) {
            <p class="item-change">
              <span class="green">+{{ historyItem.creditsAdded }}</span>
              {{ historyItem.date.toDate() | date: 'd/MM/yyyy HH:mm' }}
            </p>
          }
          @if (historyItem.creditsSpent) {
            <p class="item-change">
              <span class="red">-{{ historyItem.creditsSpent }}</span>
              {{ historyItem.date.toDate() | date: 'd/MM/yyyy HH:mm' }}
            </p>
          }
          @if (historyItem.actionBy) {
            <div class="item-info">
              @if (historyItem.actionBy) {
                <p class="item-actionby">Uitgevoerd door {{ historyItem.actionBy }}</p>
              }
              @if (historyItem.remarks) {
                <p class="item-remarks">"{{ historyItem.remarks }}"</p>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
